import { IAuth } from './IAuth';

export class SSOAuth implements IAuth {
	private _tokenPromise: Promise<string>;
	private _resolve: ((token: string) => void) | undefined = undefined;
	private _received: boolean = false;

	constructor() {
		this._tokenPromise = new Promise<string>((resolve, reject) => {
			this._resolve = resolve;
		});

		window.addEventListener('message', (event) => {
			if (event.data) {
				try {
					let ssoToken = JSON.parse(event.data);
					if (ssoToken.SSOToken) {
						if (this._resolve) {
							this._resolve(ssoToken.SSOToken);
							this._received = true;
						}
					}
				} catch {}
			}
		});
	}

	/*
    - To use this, the calling application needs to grant the scope.
      client_id is the app (not this app, the caller)
      scope is the app API scope.

    https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize?client_id=212214d6-fbfc-4196-9c2b-082ce61953ac&redirect_uri=https%3A%2F%2Flocalhost%3A44373%2Fsignin-oidc&response_type=id_token&scope=User.Read%20Files.ReadWrite.All%20Team.ReadBasic.All%20Sites.ReadWrite.All%20Channel.ReadBasic.All%20Mail.ReadWrite%20openid%20offline_access%20profile%20api://jcardy.ngrok.io/49846d18-e93a-447d-a7e6-95a709a5efbb/access_as_user


    - Then, a token will have to be acquired within the client app with the scope "api://jcardy.ngrok.io/49846d18-e93a-447d-a7e6-95a709a5efbb/access_as_user"

    - Then, that token will have to be passed to the client app in JavaScript 

    - The app has to be loaded with the ssoAppToken parameter e.g. https://jcardy.ngrok.io/?ssoAppToken=..........#personalDashboardTab
*/

	getToken = (): Promise<string> => {
		
		if(this._received) {
			return this._tokenPromise;
		
		} else {
			let token = window.localStorage.getItem('helmSSO');
			if(token) {
				return new Promise<string>((resolve) => {
					resolve(token as any);
				});
			}
		}

		return new Promise<string>(() => {});
	};

	login = (): Promise<void> => {
		return new Promise<void>(() => {});
	};

	logout = (): Promise<void> => {
		return new Promise<void>(() => {});
	};
}
